import { useEffect } from 'react'
import { styled } from 'styled-components'

interface Prop {
    setTitle: React.Dispatch<React.SetStateAction<string>>
}

const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: #ffffff;
`

const Content = styled.div`
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 50px;
    min-height: calc(100vh - 320px);
`

const Header = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    padding-left: 30px;
    border-bottom: 1px solid #e5e6eb;
`

const SetUpClassesButton = styled.a`
    width: fit-content;
    padding: 20px;
    background-color: #31c690;
    color: white;
    border: none;
    border-radius: 50px;
    font-size: 16px;
    text-decoration: none;
    &:hover {
        cursor: pointer;
        background-color: #28a57a;
    }
`

export default function ReportSetUpClasses({ setTitle }: Prop) {
    useEffect(() => {
        setTitle('Report')
    }, [])
    return (
        <Wrapper>
            <Header>
                Class Analysis Overview | Learn more about Moving The Next Gen{' '}
            </Header>
            <Content>
                Add classes and students to start assessing their movement
                skills.
                <SetUpClassesButton href="/profile">
                    Set up classes
                </SetUpClassesButton>
            </Content>
        </Wrapper>
    )
}
